// extracted by mini-css-extract-plugin
export default {"productGallery":"tL-z","inQuickShop":"uL-z"};